export const getIdToken = () => {
  for (let x = 0; x < localStorage.length; x += 1) {
    let item = localStorage.key(x);
    if (item?.includes('idToken')) {
      let idToken = localStorage.getItem(item);
      if (idToken !== null) return idToken
    }
  }
};
